import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import {
  CALCULATION_TYPE_OPTIONS,
  CalculationType,
} from '@/pages/instruments/new-instrument/constants/calculation-types'

export interface CalculationTypeFormFieldProps {}

export const CalculationTypeFormField: React.FC<CalculationTypeFormFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ calculation_type: CalculationType }>()

  return (
    <FormField
      name="calculation_type"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Calculation Type</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              value={value?.toString()}
              className={'flex flex-1 min-w-auto!'}
              placeholder={'Select a calculation type'}
              setValue={(value) =>
                setValue('calculation_type', value as CalculationType, { shouldValidate: true })
              }
              options={CALCULATION_TYPE_OPTIONS}
            />
          </FormItem>
        )
      }}
    />
  )
}
